import React, { useEffect, useMemo, useRef, useState } from "react";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { API_URL } from "../../../../utils/apiRoutes";
import { Col, Form, Overlay, Popover, Row } from "react-bootstrap";
import DaywiseModal from "../HeatMap/DaywiseModal";
import $ from "jquery";
import OutlookDayWise from "../HeatMap/OutlookDayWise";
import Loader from "../../../Loader/Loader";

const DemandCalender = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const userDetail = commonService.getLoginUserData();
    const yearsArr = [
        ...commonService.getPastYearForDropDown(5),
        ...commonService.getFutureYearForDropDown(2),
        new Date().getFullYear(),
    ]?.sort(function (a, b) {
        return a - b;
    });
    const [selectedYear, setSelectedYear] = useState(
        `${new Date().getFullYear()}`
        // "Default"
    );

    let monthNumberFromName = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
    };

    const [heatMapDetail, setHeatMapDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedType, setSelectedType] = useState({
        isPickupFrom: false,
        isOnTheBook: true,
    });
    const [maxDateForPickupFrom, setMaxDateForPickupFrom] = useState();
    const maxDateRef = useRef();
    if (maxDateForPickupFrom) {
        let date = new Date(maxDateForPickupFrom);
        maxDateRef.current = date.setDate(date.getDate() - 1);
    }
    const monthNameDetail = useRef([]);
    const date = new Date();
    let startDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );

    let endDate = commonService.getDateInDBFormat(
        date.setFullYear(date.getFullYear() + 1, date.getMonth() + 1, 0)
    );

    let currentYearStartDate = `${new Date().getFullYear()}-01-01`;
    let currentYearEndDate = `${new Date().getFullYear()}-12-31`;

    let currentWeekStartDate = commonService.getDateForNode(
        moment().startOf("week")
    );
    let currentWeekEndDate = commonService.getDateForNode(moment().endOf("week"));

    const [payloadStartDate, setPayloadStartDate] =
        useState(currentYearStartDate);
    const [payloadEndDate, setPayloadEndDate] = useState(currentYearEndDate);
    const [selectPickupDate, setSelectPickupDate] = useState();
    const [selectGroupType, setSelectGroupType] = useState("All");
    const selectedTdIndexRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const pickupDateForTotalOTB = useRef();
    const [dateRange, setDateRange] = useState({
        startDate: commonService.convertDateInTimezone(currentWeekStartDate),
        endDate: commonService.convertDateInTimezone(currentWeekEndDate),
    });
    function selectWeek(date) {
        return Array(7)
            .fill(new Date(date))
            .map((el, idx) =>
                moment(new Date(el.setDate(el.getDate() - el.getDay() + idx))).format(
                    "YYYY-MM-DD"
                )
            );
    }
    let currentWeekArr = selectWeek(new Date());
    const weekDayObjRef = useRef();

    const getMonthNameFromMonthNumber = (dateFromResponse) => {
        let date = moment(dateFromResponse).toDate();
        return date.toLocaleString("en-US", { month: "long" });
    };

    const setDateForApi = (value) => {
        setPayloadStartDate(`${value}-01-01`);
        setPayloadEndDate(`${value}-12-31`);
        setSelectedYear(value);
    };

    const getHeatMapDetail = async () => {
        setHeatMapDetail(null);
        weekDayObjRef.current = {};
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        setLoading(true);
        let heatMapResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DEMAND_DATA.DEMAND_CALENDAR,
                body: {
                    asofdate: para?.asOfDate,
                    startdate: selectedYear + "-01-01",
                    enddate: selectedYear + "-12-31",
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, heatMapResponse);

        if (response?.isValidate) {
            monthNameDetail.current = [];
            let dateForMonth = moment(new Date(selectedYear, 0, 1)).toDate();
            for (let i = 0; i <= 11; i++) {
                let monthName = getMonthNameFromMonthNumber(dateForMonth);
                monthNameDetail.current = [
                    ...monthNameDetail.current,
                    `${monthName}/${dateForMonth?.getFullYear()}`,
                ];

                dateForMonth.setMonth(dateForMonth.getMonth() + 1);
            }

            let responseData = response?.data?.data;
            singleDateSelectedDateRef.current = new Date();

            let groupingJson = {};
            

            for (let i = 0; i < responseData?.length; i++) {
                let dateKey = moment(responseData?.[i]?.StayDate).toDate();
                let monthName = getMonthNameFromMonthNumber(
                    responseData?.[i]?.StayDate
                );
                let monthIndex = monthNameDetail.current?.findIndex(
                    (x) => x === `${monthName}/${dateKey?.getFullYear()}`
                );
                let percentage = 0;
                if (responseData?.[i]?.demandscore === 0) {
                    percentage = 0;
                } else {
                    percentage = Math.round(responseData?.[i]?.demandscore);
                }
                if (monthIndex < 0) {
                    monthNameDetail.current = [
                        ...monthNameDetail.current,
                        `${monthName}/${dateKey?.getFullYear()}`,
                    ];
                }
                if (groupingJson?.hasOwnProperty(dateKey?.getDate())) {
                    groupingJson[dateKey.getDate()] = {
                        ...groupingJson?.[dateKey?.getDate()],
                        [`${monthName}/${dateKey?.getFullYear()}`]: {
                            ...responseData?.[i],
                            percentage,
                        },
                    };
                } else {
                    groupingJson = {
                        ...groupingJson,
                        [dateKey?.getDate()]: {
                            [`${monthName}/${dateKey?.getFullYear()}`]: {
                                ...responseData?.[i],
                                percentage,
                            },
                        },
                    };
                }
            }
            setHeatMapDetail(groupingJson);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setLoading(false);
            setHeatMapDetail(null);
        }

        let _scrollMonth = setInterval(function () {
            clearInterval(_scrollMonth);
            scrollUptoMonth();
        }, 500);
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                let d = moment(new Date(para?.asOfDate)).toDate();
                d.setDate(d.getDate() - 1);
                pickupDateForTotalOTB.current = moment(d).format("YYYY-MM-DD");
                setMaxDateForPickupFrom(new Date(para?.defaultAsOfDate));
                getHeatMapDetail();
            }
        }
    }, [
        para?.asOfDate,
        selectedType,
        selectedYear,
        selectGroupType,
        selectPickupDate,
    ]);

    const renderCalendar = (calDate, monthName) => {
        const calendar = [];

        let CalFirstDate = new Date(calDate.getFullYear(), calDate.getMonth(), 1);
        CalFirstDate = new Date(
            CalFirstDate.setDate(CalFirstDate.getDate() - CalFirstDate.getDay())
        );

        for (let i = 0; i < 6; i++) {
            let row = [],
                weekNumber = "",
                weekTrValue = "",
                startDateForWeek = "",
                endDateForWeek = "";
            for (let j = 0; j < 7; j++) {
                // let createdDateMonthWise=new Date(CalFirstDate.getFullYear(),)
                let DTDate = commonService.convertDateInTimezone(CalFirstDate);
                if (j === 0) {
                    weekNumber = moment(commonService.getDateInFormat(DTDate)).week();
                    weekTrValue = `${moment(
                        commonService.getDateInFormat(DTDate)
                    ).week()}/${new Date(
                        commonService.getDateInFormat(DTDate)
                    ).getFullYear()}`;
                    startDateForWeek = commonService.getDateForNode(DTDate);
                }
                if (j === 6) {
                    endDateForWeek = commonService.getDateForNode(DTDate);
                }
                let className = "lightGrayColor",
                    fontBold = false;

                let month = getMonthNameFromMonthNumber(CalFirstDate);
                let dataForCurrentdate =
                    heatMapDetail[CalFirstDate.getDate()][
                    `${month}/${CalFirstDate.getFullYear()}`
                    ];

                if (
                    dataForCurrentdate?.percentage >= 0 &&
                    dataForCurrentdate?.percentage <= 10
                ) {
                    className = "color0to19";
                } else if (
                    dataForCurrentdate?.percentage >= 11 &&
                    dataForCurrentdate?.percentage <= 20
                ) {
                    className = "color20to34";
                } else if (
                    dataForCurrentdate?.percentage >= 21 &&
                    dataForCurrentdate?.percentage <= 30
                ) {
                    className = "color35to49";
                } else if (
                    dataForCurrentdate?.percentage >= 31 &&
                    dataForCurrentdate?.percentage <= 40
                ) {
                    className = "color50to64";
                } else if (
                    dataForCurrentdate?.percentage >= 41 &&
                    dataForCurrentdate?.percentage <= 50
                ) {
                    className = "color65to74";
                } else if (
                    dataForCurrentdate?.percentage >= 51 &&
                    dataForCurrentdate?.percentage <= 60
                ) {
                    className = "color75to84";
                } else if (
                    dataForCurrentdate?.percentage >= 61 &&
                    dataForCurrentdate?.percentage <= 70
                ) {
                    className = "color85to89";
                } else if (
                    dataForCurrentdate?.percentage >= 71 &&
                    dataForCurrentdate?.percentage <= 80
                ) {
                    className = "color90to94";
                } else if (
                    dataForCurrentdate?.percentage >= 81 &&
                    dataForCurrentdate?.percentage <= 90
                ) {
                    className = "color95to100";
                } else if (dataForCurrentdate?.percentage >= 90) {
                    className = "color100above";
                }

                let isDateFromCurrentWeek = currentWeekArr?.filter(
                    (x) => x === moment(DTDate).format("YYYY-MM-DD")
                );

                if (isDateFromCurrentWeek?.length > 0) {
                    fontBold = true;
                }
                row.push(
                    <td id={commonService.generateGlobalClickTrackerID("DemandCalender", "td-onclick", "")}
                        key={`${i}-${j}`}
                        className={`${className} text-center cursorPointer ${fontBold ? "heatMapBold" : ""
                            }`}
                        onClick={(e) => {
                            weekDayObjRef.current = {};
                            singleDateSelectedDateRef.current = moment(
                                new Date(DTDate)
                            ).format("YYYY-MM-DD");
                            setDateRange({
                                startDate: commonService.convertDateInTimezone(
                                    commonService.getDateForNode(DTDate)
                                ),
                                endDate: commonService.convertDateInTimezone(
                                    commonService.getDateForNode(DTDate)
                                ),
                            });
                        }}
                    >
                        {CalFirstDate.getDate()}
                    </td>
                );
                CalFirstDate = new Date(
                    CalFirstDate.setDate(CalFirstDate.getDate() + 1)
                );
            }
            let currentWeek =
                moment(new Date()).week() === weekNumber &&
                new Date().getFullYear() == weekTrValue?.split("/")?.[1];

            row.push(
                <td
                    className={`${currentWeek ? "heatMapBold" : ""
                        } cursorPointer text-center`}
                >
                    <input id={commonService.generateGlobalClickTrackerID("DemandCalender", "heatmapdaywiseradiogroup", "")}
                        onClick={(e) => {
                            setDateRange({
                                startDate:
                                    commonService.convertDateInTimezone(startDateForWeek),
                                endDate: commonService.convertDateInTimezone(endDateForWeek),
                            });
                        }}
                        type="radio"
                        className="form-check-input cursorPointer"
                        name="heatMapDaywiseRadioGroup"
                    />
                </td>
            );
            calendar.push(
                <tr value={weekTrValue} key={i}>
                    {row}
                </tr>
            );
        }
        return calendar;
    };

    const removeDuplicateTr = () => {
        $(document).ready(function () {
            let mainDiv = document.querySelectorAll("#heamMapDayWiseTbl");
            let existingWeek = {};
            mainDiv?.forEach((item) => {
                let table = item?.querySelector("table");
                let tbody = table?.querySelectorAll("tbody tr");

                tbody?.forEach((trItem, trIndex) => {
                    let weekNumber = trItem?.attributes?.value?.nodeValue;
                    if (existingWeek[weekNumber]) {
                        trItem?.remove();
                    } else {
                        existingWeek[weekNumber] = weekNumber;
                    }
                });
            });
        });
    };

    const removeTr = useMemo(() => removeDuplicateTr(), [heatMapDetail]);

    const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S", ""];

    function scrollUptoMonth() {
        let TodayDate = new Date();
        let monthName = getMonthNameFromMonthNumber(TodayDate);
        const container = document.getElementById("asidecalendar_container");
        const target = document.getElementById(
            (monthName + "_" + TodayDate.getFullYear()).toUpperCase()
        );
        if (container && target) {
            const offsetTop = target.offsetTop - container.offsetTop;
            container.scrollTo({
                top: offsetTop,
                behavior: "smooth",
            });
        }
    }

    return (
        <div>
            <table>
                <tr>
                    <td style={{ width: "16.66666667%" }}>
                        <Row>
                            <div className="from-groups no-border-break width110">
                                <Form.Select id={commonService.generateGlobalClickTrackerID("DemandCalender", "form-select-onchange", "")}
                                    aria-label="Default select example"
                                    value={selectedYear}
                                    onChange={(e) => {
                                        setDateForApi(e.target.value);
                                    }}
                                >
                                    {yearsArr?.map((item, index) => (
                                        <option key={item} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </Row>
                    </td>
                    <td style={{ width: "83.33333333%" }}>
                        <table>
                            <tr>
                                <td>
                                    <p class="px-3 text-center color0to19">0 - 10</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color20to34">11 - 20</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color35to49">21 - 30</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color50to64">31 - 40</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color65to74">41 - 50</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color75to84">51 - 60</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color85to89">61 - 70</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color90to94">71 - 80</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color95to100">81 - 90</p>
                                </td>
                                <td>
                                    <p class="px-3 text-center color100above">91 - 100</p>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
            <Row>
                <Col className="asidecalendar">
                    <div
                        style={{
                            width: "100%",
                            maxHeight: "75vh",
                            overflowY: "auto",
                            //zIndex: 999999,
                            background: "white",
                            marginTop: "5px",
                            border: "1px solid #3565fc80",
                            borderRadius: "5px",
                        }}
                        className="asidecalendar-inner"
                        id="asidecalendar_container"
                    >
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                {heatMapDetail &&
                                    monthNameDetail.current?.map((item) => {
                                        let month = item;
                                        let monthname = month?.split("/");
                                        let dateString = `${monthname?.[1]}-${monthname?.[0]}-1`;
                                        let formatDate = moment(
                                            // `${monthname?.[1]}-${monthname?.[0]}-1`
                                            commonService.convertDateInTimezone(dateString)
                                        ).format("YYYY-MM-DD");
                                        return (
                                            <div
                                                id="heamMapDayWiseTbl"
                                                style={{ width: "100%" }}
                                                className="mt-2"
                                            >
                                                <p
                                                    className="text-center asidecalendar-month-name"
                                                    id={`${monthname?.[0]}${monthname?.[1]}`}
                                                >
                                                    {item}
                                                </p>
                                                <table
                                                    id={(
                                                        monthname?.[0] +
                                                        "_" +
                                                        monthname?.[1]
                                                    ).toUpperCase()}
                                                >
                                                    <thead>
                                                        <tr>
                                                            {daysOfWeek.map((day) => (
                                                                <th
                                                                    style={{ fontSize: "14px" }}
                                                                    className="text-center"
                                                                    key={day}
                                                                >
                                                                    {day}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {renderCalendar(
                                                            commonService.convertDateInTimezone(
                                                                new Date(`${formatDate} 00:00:00`)
                                                            ),
                                                            item
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        );
                                    })}
                                {removeTr}
                            </>
                        )}
                    </div>
                </Col>
                <Col className="asidecalendartable">
                    <div>
                        {para?.propertyCode &&
                            para?.asOfDate &&
                            pickupDateForTotalOTB.current &&
                            singleDateSelectedDateRef.current &&
                            dateRange && (
                                <div className="mt-2">
                                    <OutlookDayWise api={api} para={para} dateRange={dateRange} />
                                </div>
                            )}
                    </div>
                    {/* <div style={{ maxHeight: "79vh", overflow: "auto" }}> */}
                    <div>

                        {para?.propertyCode &&
                            para?.asOfDate &&
                            pickupDateForTotalOTB.current &&
                            singleDateSelectedDateRef.current &&
                            dateRange && (
                                <div className="mt-2">
                                    <DaywiseModal
                                        asOfDate={para?.asOfDate}
                                        pickupDate={
                                            selectedType?.isPickupFrom
                                                ? selectPickupDate
                                                : pickupDateForTotalOTB.current
                                        }
                                        propertyDetail={{ propertyCode: para?.propertyCode }}
                                        dateRange={dateRange}
                                        para={para}
                                        api={api}
                                    />
                                </div>
                            )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default DemandCalender;
